/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AxiosError } from 'axios';
import { DriverVehicleSeriesData } from 'models/viewModels';
import { MotorsportsError, MotorsportsErrorType } from 'services/motorsportsError/MotorsportsError';
import { driverApi } from './DriverApi';

class DriverServiceServer {
  async getDrivers(seriesId: string, eventId?: string, season?: number): Promise<DriverVehicleSeriesData[]> {
    return driverApi
      .getDrivers(seriesId, eventId, season)
      .then((response) => {
        return response.driverVehicleSeriesData;
      })
      .catch((error: AxiosError) => {
        throw new MotorsportsError(error.message, MotorsportsErrorType.Unknown, { cause: error });
      });
  }

  async getDriversByEventGroupId(eventGroupId: string): Promise<DriverVehicleSeriesData[]> {
    return driverApi
      .getDriversByEventGroupId(eventGroupId)
      .then((response) => response.driverVehicleSeriesData)
      .catch((error: AxiosError) => {
        throw new MotorsportsError(error.message, MotorsportsErrorType.Unknown, { cause: error });
      });
  }

  async getVehicleOemList(seriesId: string): Promise<string[]> {
    return driverApi.getVehicleOemList(seriesId).then((response) => {
      return response.oemList;
    });
  }

  //ugh with eventId vs raceId...the nascar api uses raceId so thats what is in the backend
  async getPlayoffDrivers(seriesId: string, season: number, raceId?: string) {
    return driverApi
      .getPlayoffDrivers(seriesId, season, raceId)
      .then((response) => response)
      .catch((error: AxiosError) => {
        throw new MotorsportsError(error.message, MotorsportsErrorType.Unknown, { cause: error });
      });
  }

  async getDriversByEventId(eventId: string) {
    return driverApi
      .getDriversByEventId(eventId)
      .then((response) => response)
      .catch((error: AxiosError) => {
        throw new MotorsportsError(error.message, MotorsportsErrorType.Unknown, { cause: error });
      });
  }

  async getDistinctSeriesVehicles(seriesId: number): Promise<DriverVehicleSeriesData[]> {
    return driverApi.getDistinctSeriesVehicles(seriesId).then((response) => {
      return response.driverVehicleSeriesData;
    });
  }
}

export const driverService = new DriverServiceServer();
